const getDefaultState = () => {
    return {
        vehicleCategory: "",
        vehicleBrand: "",
        vehicleModel: "",
        vehicleVersion: "",
        fromCotation: false
    }
};

const state = getDefaultState();

const getters = {
    getVehicleSelectByKey: (state) => key => state[key],
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    setFromCotation(state, fromCotation) {
        state.fromCotation = fromCotation;
    },
    setVehicleSelectByKey(state, array) {
        state[array.key] = array.value
    },
};

const actions = {
    resetVehicleState({ commit }) {
        commit('resetState');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
